import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../../../PageHeader';
import CorporateSectionLayout from '../../../CorporateSectionLayout';
import SistemPengaduan from './SistemPengaduan';

function SistemPengaduanPelanggaranLayout() {
    const items = [{ id: 'sistem-pengaduan', number: '01', label: 'Sistem Pengaduan', content: <SistemPengaduan /> }];
    return <>
        <Helmet><title>Sistem Pengaduan Pelanggaran | PT Len Telekomunikasi Indonesia</title><meta name="description" content="Sistem Pengaduan Pelanggaran PT Len Telekomunikasi Indonesia." /><link rel="canonical" href="https://www.len-telko.co.id/tata-kelola-perusahaan/sistem-pengaduan-pelanggaran" /></Helmet>
        <PageHeader title="Sistem Pengaduan Pelanggaran" />
        <CorporateSectionLayout title="Sistem Pengaduan Pelanggaran" eyebrow="Tata Kelola Perusahaan" items={items} />
    </>;
}
export default SistemPengaduanPelanggaranLayout;
